import { useState } from 'react';
import { useSelector } from 'react-redux';
import AddNoteComponent from '../../../PharmacyNotes/ModalViews/components/AddNoteComponent';
import NotesListComponent from '../../../PharmacyNotes/ModalViews/components/NotesListComponent';
import ordersApi from '../../../../../../apis/orders';

const OrderNotes = ({ order, defaultView = 'list' }) => {
  const { _id, support_notes = [] } = order;
  const [noteTab, setNoteTab] = useState(defaultView);
  const [notes, setNotes] = useState(support_notes);
  const [isLoading, setIsLoading] = useState(false);
  const {
    user: { user_id, username, forename, surname } = {},
  } = useSelector(state => state.authentication);

  const addNewOrderNote = async (noteText, e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const [response] = await ordersApi.addOrderNotes(_id, [
        {
          date_created: Math.round(Date.now() / 1000),
          text: noteText,
          author_id: user_id,
          author: {
            forename,
            surname,
            username,
          },
        },
      ]);
      const { support_notes: updatedSupportNotes = [] } = response || {};
      const newNotesList = [...notes, ...updatedSupportNotes];
      setNotes(newNotesList);
      order.support_notes = newNotesList;
      setNoteTab('list');
    } catch (error) {
      console.log(error);
    }

    setIsLoading(false);
  };

  return noteTab === 'list' ? (
    <NotesListComponent
      notes={notes}
      handleAddNote={() => setNoteTab('add_note')}
    />
  ) : (
    <AddNoteComponent
      isFetching={isLoading}
      handleSubmit={addNewOrderNote}
      handleGoToList={() => setNoteTab('list')}
    />
  );
};

export default OrderNotes;
